<template>
  <section :class="['product-filter', { 'product-filter--drawer': showClose }]">
    <div class="product-filter__container">
      <div class="product-filter__head">
        <b>{{ title }}</b>
        <button v-if="showClose" class="product-filter__close" type="button" @click="toggleOpen">Закрыть</button>
      </div>

      <div v-if="selectedChips().length > 0" class="product-filter__selected">
        <div v-for="item in selectedChips()" :key="item.key" class="selected-item">
          <span class="item-name">{{ item.name }}</span>
          <button class="selected-item__remove" type="button" @click="item.onRemove">x</button>
        </div>
      </div>

      <div v-if="selectedPriceLabel()" class="product-filter__selected">
        <div class="selected-item selected-item--price">
          <span class="item-name">{{ selectedPriceLabel() }}</span>
        </div>
      </div>

      <div v-if="selectedFiltersAmount() > 0 || selectedPriceChanged()" class="product-filter__reset-wrap">
        <div class="product-filter__summary">Выбрано: {{ selectedSummaryLabel() }}</div>
        <button class="product-filter__reset" type="button" @click="resetFilters()">
          Очистить фильтры
        </button>
      </div>

      <div class="product-filter__body">
        <Accordion v-if="filterOptions.colors.length > 0" title="Цвет" class="product-filter__body__accordion">
          <div class="item-group item-group--with-buttons colors">
              <div v-for="color in filterOptions.colors" :key="color.id" class="item filter-choice">
                <input :id="`color-${color.id}`" v-model="selected.colors" class="filter-choice__input" type="checkbox" :value="color.id">
                <label :for="`color-${color.id}`" class="filter-choice__label">
                {{ color.name }}
              </label>
            </div>
          </div>
        </Accordion>

        <template v-for="group in optionsByGroup()" :key="group[0].optionName">
          <Accordion :title="group[0].optionName" class="product-filter__body__accordion">
            <div class="item-group item-group--with-buttons options">
              <div v-for="option in group" :key="option.id" class="item">
                <input :id="`option-${option.id}`" v-model="selected.options" class="filter-choice__input" type="checkbox" :value="option.id">
                <label :for="`option-${option.id}`" class="filter-choice__label">
                  {{ option.name }}
                </label>
              </div>
            </div>
          </Accordion>
        </template>

        <Accordion v-if="filterOptions.manufacturers.length > 0" title="Бренд" class="product-filter__body__accordion">
          <div class="item-group item-group--with-buttons manufacturers">
            <div v-for="manufacturer in filterOptions.manufacturers" :key="manufacturer.id" class="item">
                <input :id="`manufacturer-${manufacturer.id}`" v-model="selected.manufacturers" class="filter-choice__input" type="checkbox" :value="manufacturer.id">
                <label :for="`manufacturer-${manufacturer.id}`" class="filter-choice__label">
                {{ manufacturer.name }}
              </label>
            </div>
          </div>
        </Accordion>

        <div class="product-filter__price">
          <p class="product-filter__price-label">Цена, ₽</p>

          <div class="product-filter__price-fields">
            <label class="uk-field">
              <span class="uk-field__label">От</span>
              <input v-model.number="selected.minPrice" class="uk-input uk-input-sm" min="0" type="number">
            </label>

            <label class="uk-field">
              <span class="uk-field__label">До</span>
              <input v-model.number="selected.maxPrice" class="uk-input uk-input-sm" min="0" type="number">
            </label>
          </div>
        </div>
      </div>
    </div>

    <div :class="['product-filter__footer-wrapper', { 'product-filter__footer-wrapper--pending': hasPendingChanges() }]">
      <div class="product-filter__footer">
        <p v-if="hasPendingChanges()" class="product-filter__submit-hint">
          Фильтры изменены. Нажмите кнопку, чтобы обновить товары.
        </p>

        <button class="uk-button uk-button-primary product-filter__submit" type="button" @click="submitFilters">
          Применить фильтры
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Accordion from "../accordion.vue";

const OPTIONS = "options"
const MANUFACTURERS = "manufacturers"
const COLORS = "colors"

export default {
  emits: ['toggle-sidemenu', 'apply-filters'],
  props: {
    categoryId: String,
    title: {
      type: String,
      default: 'Фильтры',
    },
    showClose: Boolean,
    filterOptions: {
      type: Object,
      default: () => ({
        manufacturers: [],
        options: [],
        colors: [],
        minPrice: 0,
        maxPrice: 0,
      }),
    },
  },
  components: {
    Accordion,
  },
  data: () => {
    return {
      applied: {
        manufacturers: [],
        options: [],
        colors: [],
        minPrice: 0,
        maxPrice: 0,
      },
      selected: {
        manufacturers: [],
        options: [],
        colors: [],
        minPrice: 0,
        maxPrice: 0,
      },
    };
  },
  created: function() {
    this.syncSelectedFromLocation()
    this.applied = this.selectionSnapshot()
  },

  methods: {
    toggleOpen: function() { this.$emit('toggle-sidemenu', 'filter'); },
    filterCategories: function() { return [OPTIONS, MANUFACTURERS, COLORS] },

    submitFilters: function() {
      const maxPrice = (this.selected.maxPrice == this.filterOptions.maxPrice) ? undefined : this.selected.maxPrice
      const minPrice = (this.selected.minPrice == this.filterOptions.minPrice) ? undefined : this.selected.minPrice
      const params = {
        product_category_id: this.categoryId,
        manufacturer_ids: this.selected.manufacturers,
        option_ids: this.selected.options,
        color_ids: this.selected.colors,
        min_price: minPrice,
        max_price: maxPrice,
      };
      this.applied = this.selectionSnapshot();
      this.$emit('apply-filters', params);
    },

    hasPendingChanges: function() {
      return JSON.stringify(this.selectionSnapshot()) !== JSON.stringify(this.applied)
    },

    selectedItems: function() {
      let itemsByGroup = {};

      this.filterCategories().forEach((category) => {
        itemsByGroup[category] = this.selected[category]
          .map((selectedItem) => {
            return this.filterOptions[category].find((i) => i.id == selectedItem)
          })
          .filter(Boolean)
      });

      return itemsByGroup
    },

    selectedChips: function() {
      const itemsByGroup = this.selectedItems()

      return this.filterCategories().flatMap((category) => {
        return itemsByGroup[category].map((item) => ({
          key: `${category}-${item.id}`,
          name: item.name,
          onRemove: () => this.deselect(item.id, category),
        }))
      })
    },

    selectedFiltersAmount: function() {
      return this.filterCategories().reduce((acc, cat) => {
        return acc + this.selected[cat].length
      }, 0);
    },

    selectedPriceChanged: function() {
      return this.selected.minPrice != this.filterOptions.minPrice || this.selected.maxPrice != this.filterOptions.maxPrice
    },

    selectedPriceLabel: function() {
      if (!this.selectedPriceChanged()) {
        return null
      }

      const minPrice = this.selected.minPrice || this.filterOptions.minPrice
      const maxPrice = this.selected.maxPrice || this.filterOptions.maxPrice

      return `Цена: ${minPrice} - ${maxPrice} ₽`
    },

    selectedSummaryLabel: function() {
      const amount = this.selectedFiltersAmount()

      if (this.selectedPriceChanged()) {
        return amount > 0 ? `${amount} параметра и цена` : 'цена'
      }

      return `${amount}`
    },

    syncSelectedFromLocation: function() {
      const params = new URLSearchParams(window.location.search)

      this.selected.manufacturers = this.readArrayParam(params, 'manufacturer_ids')
      this.selected.options = this.readArrayParam(params, 'option_ids')
      this.selected.colors = this.readArrayParam(params, 'color_ids')
      this.selected.minPrice = this.readNumberParam(params, 'min_price', this.filterOptions.minPrice)
      this.selected.maxPrice = this.readNumberParam(params, 'max_price', this.filterOptions.maxPrice)
    },

    readArrayParam: function(params, key) {
      return params.getAll(`${key}[]`).concat(params.getAll(key)).filter(Boolean)
    },

    readNumberParam: function(params, key, fallback) {
      const value = params.get(key)

      if (value === null || value === '') {
        return fallback
      }

      const parsed = Number(value)
      return Number.isNaN(parsed) ? fallback : parsed
    },

    selectionSnapshot: function() {
      return {
        manufacturers: this.normalizeSelectedIds(this.selected.manufacturers),
        options: this.normalizeSelectedIds(this.selected.options),
        colors: this.normalizeSelectedIds(this.selected.colors),
        minPrice: this.normalizePrice(this.selected.minPrice, this.filterOptions.minPrice),
        maxPrice: this.normalizePrice(this.selected.maxPrice, this.filterOptions.maxPrice),
      }
    },

    normalizeSelectedIds: function(items) {
      return items.map(String).sort()
    },

    normalizePrice: function(value, fallback) {
      return Number(value || fallback)
    },

    resetFilters: function() {
      window.location = window.location.pathname;
    },

    deselect: function(id, type) {
      let index = this.selected[type].indexOf(id);
      if (index !== -1) {
        this.selected[type].splice(index, 1);
      }
    },

    optionsByGroup: function() {
      if (this.filterOptions.options === undefined) {
        return []
      }

      return Object.values(this.filterOptions.options.reduce((result, currentItem) => {
        (result[currentItem['optionName']] = result[currentItem['optionName']] || []).push(currentItem);
        return result;
      }, {}));
    },
  }
};

</script>
